import React from 'react';
import PropTypes from 'prop-types';

const SearchView = ({ 
  placeholder = '', 
  value = '', 
  onChange, 
  leftImage = null,
  className = '',
  ...props 
}) => {
  return (
    <div className={`relative ${className}`}>
      {leftImage && (
        <div className="absolute left-[24px] top-1/2 transform -translate-y-1/2">
          <img 
            src={leftImage?.src} 
            className={`w-[${leftImage?.width}px] h-[${leftImage?.height}px]`}
            alt="search"
          />
        </div>
      )}
      <input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full text-[24px] font-rubik font-normal leading-[29px] text-left text-global-1 bg-global-5 rounded-[34px] px-[74px] py-[16px] pr-[12px] focus:outline-none focus:ring-2 focus:ring-global-1 focus:border-transparent"
        {...props}
      />
    </div>
  );
};

SearchView.propTypes = {
  placeholder: PropTypes?.string,
  value: PropTypes?.string,
  onChange: PropTypes?.func,
  leftImage: PropTypes?.shape({
    src: PropTypes?.string,
    width: PropTypes?.number,
    height: PropTypes?.number
  }),
  className: PropTypes?.string,
};

export default SearchView;